import { ContentService as ContentService } from "./content"

export * from "./content"
export * from "./utils"

const Api = {
   content: new ContentService,
}

export default Api
